import { render, staticRenderFns } from "./ShareableProfileInfo.vue?vue&type=template&id=0e7b5545&"
import script from "./ShareableProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./ShareableProfileInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports